import { React } from 'react';

const FeedComments = (props) => {
    const firstName = props.postComments.commenter.first_name;
    const lastName = props.postComments.commenter.last_name;

    return (
        <div className="feed-post-comment-line">
            <p className="feed-post-content-comment-name">
                {firstName} {lastName}
            </p>
            <p className="feed-post-content-comment">
                {props.postComments.comment}
            </p>
        </div>
    );
};

export default FeedComments;
